// The cards part. This component renders the cards or carousel children below the carouse

import React, { memo } from 'react';
import { CardTrackProps } from './Carousel.types';
import './carousel.styles.css';
import { CHEVRON_RIGHT_ICON } from '@Images';

export const CardTracker = memo(({ items, trackRef, renderItem, onCardFocus }: CardTrackProps) => {
  return (
    <div className="nium-carousel-track" ref={trackRef} role="group" aria-label="Carousel items">
      {items.map((item, i) => {
        const key = item.name ?? `${item.heading}-${i}`;
        return renderItem ? (
          <div key={key} tabIndex={-1}>
            {renderItem(item, i)}
          </div>
        ) : (
          <div
            key={key}
            className="nium-carousel-card"
            tabIndex={0}
            onFocus={() => onCardFocus(i)}
            role="group"
            aria-roledescription="slide"
            aria-label={`${i + 1} of ${items.length}: ${item.heading}`}
          >
            <div>
              <h3 className="nium-carousel-card-title">{item.heading}</h3>
              <p className="nium-carousel-card-body">{item.description}</p>
            </div>
            {item.ctaUrl ? (
              <a className="nium-carousel-card-link" href={item.ctaUrl} onClick={item.ctaOnClick}>
                {item.ctaText}{' '}
                <img
                  alt="next"
                  width={16}
                  height={16}
                  src={CHEVRON_RIGHT_ICON}
                  aria-hidden="true"
                />
              </a>
            ) : (
              <button className="nium-carousel-card-link" onClick={item.ctaOnClick} type="button">
                {item.ctaText}{' '}
                <img
                  alt="next"
                  width={16}
                  height={16}
                  src={CHEVRON_RIGHT_ICON}
                  aria-hidden="true"
                />
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
});
